import React from 'react';

export interface ILoadingProps {
  className?: string;
}

export function Loading(props: ILoadingProps) {
  return <div className={`flex-centering ${props.className || ''}`}>Loading...</div>;
}
